



















































































































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { mapGetters, mapState } from "vuex";

import { STORE_KEY, store } from "../ProductContainerForm/_store";
import { resolveCatalogEntityId } from "../utils/openCatalogEntity";

@Component({
  computed: {
    ...mapState(STORE_KEY, [
      "loaded",
      "loading",
      "fatalError",
      "document",
      "form",
      "meta",
      "stickers",
      "primeCostForm",
      "productName",
      "baseContainerName",
    ]),
    ...mapGetters(STORE_KEY, ["fields"]),
  },
})
export default class ProductContainerViewForm extends Vue {
  @Prop({ type: Object }) documentPreview!: any;

  document!: any;
  form!: any;
  meta!: any;
  stickers!: any[];
  productName!: string | null;
  baseContainerName!: string | null;

  public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  }

  public mounted() {
    const entityId = resolveCatalogEntityId(this, this.documentPreview);
    if (entityId != null) {
      this.$store.dispatch(`${STORE_KEY}/init`, {
        id: entityId,
      });
    }
  }

  get productNameLabel() {
    if (this.productName) {
      return this.productName;
    }
    if (this.documentPreview && this.documentPreview.product_name) {
      return this.documentPreview.product_name;
    }
    if (this.form && this.form.product_id && this.meta && this.meta.products) {
      const product = this.meta.products.find(
        (p: any) => p.id === this.form.product_id
      );
      return product ? product.name : "-";
    }
    return "-";
  }

  get baseContainerNameLabel() {
    if (this.baseContainerName) {
      return this.baseContainerName;
    }
    if (
      this.form &&
      this.form.base_product_container_id &&
      this.meta &&
      this.meta.product_containers
    ) {
      const container = this.meta.product_containers.find(
        (c: any) => c.id === this.form.base_product_container_id
      );
      return container ? container.name : "-";
    }
    return "-";
  }

  beforeDestroy() {
    this.$store.dispatch(`${STORE_KEY}/reset`);
  }
}
